import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BackArrow } from 'src/Admin/img/Reports/ReportsSvgImages';
import AutoSuggestionSelectComponent from '../../common/AutoSuggestSelect/Select';
import useGenerateReport from '../hooks/useGenerateReport';
import ReportForm from './ReportForm';
import { ToastContainer } from 'react-toastify';

const GenerateReports = () => {
  const { t } = useTranslation();
  const {
    dispatch,
    getReportCategoryAndName,
    generateReport,
    setReportCategory,
    setReportName,
    resetGenerateReport,
    getDynamicFieldsData,
    resetBlobData,
  } = useGenerateReport();

  useEffect(() => {
    if (generateReport?.reportCategoryDropdownOptions?.length === 0) {
      getReportCategoryAndName('CATEGORY');
    }
    if (generateReport?.reportCategory) {
      getReportCategoryAndName('NAME', generateReport?.reportCategory);
    }
  }, [generateReport?.reportCategory]);

  useEffect(() => {
    if (generateReport?.reportName) {
      dispatch(resetBlobData());
      getDynamicFieldsData(generateReport?.reportName);
    }
  }, [generateReport?.reportName]);

  useEffect(() => {
    if (generateReport?.reportCategory) {
      dispatch(resetBlobData());
    }
  }, [generateReport?.reportCategory]);

  useEffect(() => {
    return () => {
      dispatch(resetGenerateReport());
    };
  }, []);

  return (
    <div className="reports">
      <div className="header-container">
        <div className="d-flex align-items-center">
          <span>
            <Link
              to={{
                pathname: '/admin/reports',
              }}
              className="back-link-arrow"
            >
              <BackArrow className="back-link-arrow" />
            </Link>
          </span>
          <h1 className="reports-header">
            {t('admin.pages.reports.generate_report_heading')}
          </h1>
        </div>
      </div>
      <div className="devider" />
      <div className="generate-report-container">
        <Card className="report-info-card-container">
          <div className="reports-data-dropdown-container">
            <div className="flex-1">
              <span className="input-label-container">
                Report Category <span className="text-danger">*</span>
              </span>
              <AutoSuggestionSelectComponent
                options={generateReport?.reportCategoryDropdownOptions}
                name="reportCategories"
                placeholder="Select Report Category"
                components={{ IndicatorSeparator: () => null }}
                value={generateReport?.reportCategory}
                onChange={(e) => {
                  dispatch(setReportCategory(e));
                }}
                isSearchable={false}
                isRequired={true}
                inputClassName="w-100"
              />
            </div>
            <div className="flex-1">
              <span className="input-label-container">
                Report Name <span className="text-danger">*</span>
              </span>
              <AutoSuggestionSelectComponent
                options={generateReport?.reportNameDropdownOptions}
                name="reportName"
                placeholder="Select Report Name"
                components={{ IndicatorSeparator: () => null }}
                value={generateReport?.reportName}
                onChange={(e) => {
                  dispatch(setReportName(e));
                }}
                isSearchable={false}
                isRequired={true}
                inputClassName="w-100"
                isDisabled={!generateReport?.reportCategory?.value}
              />
            </div>
          </div>
          {/*<div className="d-flex mt-4">
            <div className="report-formate">Report Format </div>
            <div className="reports-info-checkbox-container">
              {fileFormat?.pdf && (
                <Checkbox
                  key="generate-report-pdf-Key"
                  label="PDF"
                  className="d-none"
                  value="pdf"
                  id="generate-report-pdf"
                  name="generate-report-pdf"
                  onChange={e => {
                    setPdfCheck(!pdfCheck);
                  }}
                  checked={pdfCheck}
                />
              )}
              {fileFormat?.excel && (
                <Checkbox
                  key="generate-report-excel-Key"
                  label="XLS"
                  className="d-none"
                  value="xls"
                  id="generate-report-excel"
                  name="generate-report-excel"
                  onChange={e => {
                    setExcelCheck(!excelCheck);
                  }}
                  checked={excelCheck}
                />
              )}
            </div>
          </div> */}
        </Card>
        {generateReport?.reportName?.value && (
          <Card className="report-info-card-container">
            <ReportForm />
          </Card>
        )}
      </div>
      <div className="generate-reports-toastify-container">
        <ToastContainer
          position="top-center"
          autoClose={false}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

export default GenerateReports;
